import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// state

import Snackbar from '@/components/custom-components/snackbar/snackbar.state'
import auth from './modules/auth/index'
import locations from './modules/locations/index'
import signage from '@/store/modules/signage/index.js'
import business from '@/store/modules/Business'

const initialState = {
  Snackbar: Snackbar.state,
  auth: auth.state,
  business: business.state,
  locations: {
    allLocations: [],
    searchedLocations: [],
    location: {},
    locationAddress: {},
    users: [],
    allLocationGroups: [],
    locationGroupWithLocations: {}
  },
  signage: {
    allDevices: [],
    allDevicesPagedWithLocations: [],
    beaconLogs: [],
    devicesSummary: '',
    devicesCampaigns: '',
    requestsByDevice: [],
    devicesStatusLogs: '',
    recentReports: []
  }
}

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    Snackbar,
    auth,
    locations,
    signage,
    business
  },
  state: {},
  mutations: {
    CLEAR_STATE(state) {
      console.log(initialState)

      Object.keys(state).forEach((key) => {
        Object.assign(state[key], initialState[key])
      })
      auth.state.user = {}
      business.state.businessList = []
    }
  },
  actions: {}
})
